<script setup>
import { useMobileSajuLnbStore } from '@/store/modules/mobileSajuLnb';
import { usePrimarySajuStore } from '@/store/modules/primarySaju';

import SajuInsightHome from './components/SajuInsightHome.vue';

definePage({ meta: { layout: 'm-saju-insight' } });

const mobileSajuLnbStore = useMobileSajuLnbStore();
const primarySajuStore = usePrimarySajuStore();

// store에 guestUserId가 있으면 사용 (하위 페이지에서 복귀 시)
const guestUserId = ref(mobileSajuLnbStore.guestUserId || null);
const homeRef = ref(null);

// primary 모드 즉시 설정 (레이아웃 헤더 숨김)
mobileSajuLnbStore.setMode('primary');

onMounted(async () => {
  if (guestUserId.value) return;

  // primarySaju에서 guestUserId 조회
  if (!primarySajuStore.mySajuId) {
    await primarySajuStore.fetchMySaju();
  }
  const id = mobileSajuLnbStore.guestUserId || primarySajuStore.mySajuId;
  if (!id) {
    homeRef.value?.showAlert({
      title: '유효하지 않은 사주 정보입니다.',
      nextUrl: homeRef.value?.closeSajuInsight,
    });
    if (homeRef.value) homeRef.value.initializing.value = false;
    return;
  }
  guestUserId.value = id;
  mobileSajuLnbStore.setGuestUserId(id);
});
</script>

<template>
  <SajuInsightHome ref="homeRef" :guestUserId="guestUserId" />
</template>

